"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Counter = void 0;

var _collector = require("./collector");

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var Counter =
/*#__PURE__*/
function (_Collector) {
  _inherits(Counter, _Collector);

  function Counter() {
    _classCallCheck(this, Counter);

    return _possibleConstructorReturn(this, _getPrototypeOf(Counter).apply(this, arguments));
  }

  _createClass(Counter, [{
    key: "inc",
    value: function inc(labels) {
      this.add(1, labels);
      return this;
    }
  }, {
    key: "add",
    value: function add(amount, labels) {
      if (amount < 0) {
        throw new Error("Expected increment amount to be greater than -1. Received: ".concat(amount));
      }

      var metric = this.get(labels);
      this.set(metric ? metric.value + amount : amount, labels);
      return this;
    }
  }, {
    key: "reset",
    value: function reset(labels) {
      this.set(0, labels);
    }
  }]);

  return Counter;
}(_collector.Collector);

exports.Counter = Counter;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uL3NyYy9jb3VudGVyLnRzIl0sIm5hbWVzIjpbIkNvdW50ZXIiLCJsYWJlbHMiLCJhZGQiLCJhbW91bnQiLCJFcnJvciIsIm1ldHJpYyIsImdldCIsInNldCIsInZhbHVlIiwiQ29sbGVjdG9yIl0sIm1hcHBpbmdzIjoiOzs7Ozs7O0FBQUE7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0lBR2FBLE87Ozs7Ozs7Ozs7Ozs7d0JBQ1BDLE0sRUFBdUI7QUFDekIsV0FBS0MsR0FBTCxDQUFTLENBQVQsRUFBWUQsTUFBWjtBQUNBLGFBQU8sSUFBUDtBQUNEOzs7d0JBRUdFLE0sRUFBZ0JGLE0sRUFBdUI7QUFDekMsVUFBSUUsTUFBTSxHQUFHLENBQWIsRUFBZ0I7QUFDZCxjQUFNLElBQUlDLEtBQUosc0VBQXdFRCxNQUF4RSxFQUFOO0FBQ0Q7O0FBQ0QsVUFBTUUsTUFBTSxHQUFHLEtBQUtDLEdBQUwsQ0FBU0wsTUFBVCxDQUFmO0FBQ0EsV0FBS00sR0FBTCxDQUFTRixNQUFNLEdBQUdBLE1BQU0sQ0FBQ0csS0FBUCxHQUFlTCxNQUFsQixHQUEyQkEsTUFBMUMsRUFBa0RGLE1BQWxEO0FBRUEsYUFBTyxJQUFQO0FBQ0Q7OzswQkFFS0EsTSxFQUF1QjtBQUMzQixXQUFLTSxHQUFMLENBQVMsQ0FBVCxFQUFZTixNQUFaO0FBQ0Q7Ozs7RUFsQjBCUSxvQiIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IENvbGxlY3RvciB9IGZyb20gJy4vY29sbGVjdG9yJztcbmltcG9ydCB7IENvdW50ZXJWYWx1ZSwgTGFiZWxzIH0gZnJvbSAnLi90eXBlcyc7XG5cbmV4cG9ydCBjbGFzcyBDb3VudGVyIGV4dGVuZHMgQ29sbGVjdG9yPENvdW50ZXJWYWx1ZT4ge1xuICBpbmMobGFiZWxzPzogTGFiZWxzKTogdGhpcyB7XG4gICAgdGhpcy5hZGQoMSwgbGFiZWxzKTtcbiAgICByZXR1cm4gdGhpcztcbiAgfVxuXG4gIGFkZChhbW91bnQ6IG51bWJlciwgbGFiZWxzPzogTGFiZWxzKTogdGhpcyB7XG4gICAgaWYgKGFtb3VudCA8IDApIHtcbiAgICAgIHRocm93IG5ldyBFcnJvcihgRXhwZWN0ZWQgaW5jcmVtZW50IGFtb3VudCB0byBiZSBncmVhdGVyIHRoYW4gLTEuIFJlY2VpdmVkOiAke2Ftb3VudH1gKTtcbiAgICB9XG4gICAgY29uc3QgbWV0cmljID0gdGhpcy5nZXQobGFiZWxzKTtcbiAgICB0aGlzLnNldChtZXRyaWMgPyBtZXRyaWMudmFsdWUgKyBhbW91bnQgOiBhbW91bnQsIGxhYmVscyk7XG5cbiAgICByZXR1cm4gdGhpcztcbiAgfVxuXG4gIHJlc2V0KGxhYmVscz86IExhYmVscyk6IHZvaWQge1xuICAgIHRoaXMuc2V0KDAsIGxhYmVscyk7XG4gIH1cbn1cbiJdfQ==